<div class="app-body">
  <main class="main d-flex align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-md-6 mx-auto">
          <div class="card-group">
            <div class="card mb-4 p-4">
              <div class="card-body">Loading...</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
